(() => {
  /**=================================================================
   * Bundle Product Custom Element
   * =================================================================
  */
  void 0 === window.customElements.get("product-card-2") &&
    (window.customElements.define( 
      "product-card-2",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.tooltips = this.querySelectorAll(
              "[data-product-card-tooltip]"
            )),
            void 0 !== this.tooltips &&
              null !== this.tooltips &&
              this.initTooltips();
        }
        initTooltips() {
          this.tooltips.forEach((t) => {
            this.initTippy(t);
          });
        }
        initTippy(t) {
          const e = t.getAttribute("data-product-card-tooltip"),
            a = t.getAttribute("data-product-card-tooltip-content");
          t.hasAttribute("data-product-card-tooltip-content") &&
            tippy(`[data-product-card-tooltip="${e}"]`, {
              content: a,
              duration: 300,
              interactive: !0,
            });
        }
      })
    )

  if (typeof window.customElements.get('bundle-product') !== 'undefined') { return }
  window.customElements.define('bundle-product', class BundleProduct extends HTMLElement {
    constructor () {
      super()

      this.tooltips = this.querySelectorAll('[data-bundle-section-tooltip]')
      this.initTooltips()
    }

    initTooltips () {
      if (typeof this.tooltips === 'undefined' || this.tooltips === null) { return }

      this.tooltips.forEach(tooltip => {
        this.initTippy(tooltip)
      })
    }

    initTippy (tooltip) {
      const tooltipId = tooltip.getAttribute('data-bundle-section-tooltip')
      const tooltipContent = tooltip.getAttribute('data-bundle-section-tooltip-content')

      if (tooltip.hasAttribute('data-bundle-section-tooltip-addon')) {
        tippy(`[data-bundle-section-tooltip="${tooltipId}"]`, {
          content: tooltipContent,
          duration: 300,
          interactive: true,
          placement: 'bottom'
        });
      } else {
        tippy(`[data-bundle-section-tooltip="${tooltipId}"]`, {
          content: tooltipContent,
          duration: 300,
          interactive: true
        });
      }
    }

    // initBundleList () {
    //   const bundleItemsData = sessionStorage.getItem('bundleList')
    //   if (bundleItemsData === null || bundleItemsData === '') { return }

    //   const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')

    //   bundleItemsJson.forEach(item => {
    //     const bundleItemEl = bundleItemTemplate(item.id, item.cid, item.quantity, item.sellingPlans, item.title, item.image, item.price, item.type, item.max)
    //     const doc = this.parser.parseFromString(bundleItemEl, 'text/html')
    //     const element = doc.querySelector('bundle-item')
    //     if (!element) { return }
    //     this.bundleList.appendChild(element)
    //   })
    // }
  })

  /**=================================================================
   * Bundle Quantity Selector
   * =================================================================
  */
  window.customElements.define('bundle-quantity-selector', class BundleQuantitySelector extends HTMLElement {
    constructor () {
      super()
      this.parser = new DOMParser()
      this.bundleList = document.querySelector('bundle-summary-items')
      this.bundleTypes = document.querySelectorAll('[data-bundle-type]')
      this.bundleOptions = document.querySelectorAll('[data-bundle-reference]')
      this.currentType = [...this.bundleTypes][0]

      this.addText = this.querySelector('[data-bqs-add-text]')
      this.input = this.querySelector('[data-bqs-input]')
      this.itemCID = this.getAttribute('data-bundle-option-cid')
      this.itemID = this.getAttribute('data-bundle-option-id')
      this.itemTitle = this.getAttribute('data-bundle-item-title')
      this.itemImage = this.getAttribute('data-bundle-item-image')
      this.itemPrice = this.getAttribute('data-bundle-quantity-selector')
      this.itemComparePrice = this.getAttribute('data-bundle-compare-at-price')
      this.itemSellingPlanIDs = this.getAttribute('data-bundle-selling-plan-ids')
      this.itemType = this.getAttribute('data-bundle-item-type')
      this.itemMax = this.input.getAttribute('max')
      this.add = this.querySelector('[data-bqs-add]')
      this.subtract = this.querySelector('[data-bqs-subtract]')
      this.value = 0
      this.max = parseInt(this.input.getAttribute('max'))
      this.matchingProductCards = this.findMatchingProductCards()

      this.initTypeListeners()
      this.initQuantitySelector()
      this.initSubscriptionSelector()
      
      // Check for bundle state in URL and restore if present
      this.restoreBundleStateFromURL()
    }
    // Add method to restore bundle state from URL
    restoreBundleStateFromURL() {
      // Check if the bundle state has been restored, if it has then exit early
      if (window.__bundleStateRestored) return false

      const urlParams = new URLSearchParams(window.location.search)
      const bundleParam = urlParams.get('bundle')

      if (!bundleParam) return false
      
      try {
        const stateJson = atob(bundleParam)
        const state = JSON.parse(stateJson)
        
        // Set bundle type
        if (state.bundleTypeId) {
          const bundleTypeEl = document.querySelector(`[data-bundle-type="${state.bundleTypeId}"]`)
          if (bundleTypeEl) {
            bundleTypeEl.click()
            // Update the current type
            this.currentType = bundleTypeEl
          }
        }
        
        // Set subscription option
        if (state.subscription) {
          const subscriptionOption = document.querySelector('[data-bsw-subscription-option] input')
          if (subscriptionOption) {
            subscriptionOption.checked = true
            subscriptionOption.dispatchEvent(new Event('change'))
          }
          
          // Set selling plan
          if (state.sellingPlanId) {
            const sellingPlanSelect = document.querySelector('[data-bsw-selling-plan-select]')
            if (sellingPlanSelect) {
              sellingPlanSelect.value = state.sellingPlanId
              sellingPlanSelect.dispatchEvent(new Event('change'))
            }
          }
        }
        
        // Add items to bundle
        if (state.items && state.items.length) {
          state.items.forEach(item => {
            console.log("item", item)
            // Find the selector for this item
            const selector = document.querySelector(`[data-bundle-option-id="${item.id}"]`)
            if (selector) {
              // Set quantity
              const input = selector.querySelector('[data-bqs-input]')
              if (input) {
                input.value = item.quantity
                // Trigger change event to update the bundle
                input.dispatchEvent(new Event('change'))
                
                // Update the selector UI
                const addText = selector.querySelector('[data-bqs-add-text]')
                if (addText) {
                  // Hide the "Add" text and show the quantity controls
                  addText.style.display = 'none'
                  
                  // Show the quantity controls
                  const quantityControls = selector.querySelectorAll('button, input')
                  quantityControls.forEach(control => {
                    if (control !== addText) {
                      control.style.display = 'flex'
                    }
                  })
                }
                
                // Update the bundle
                const selectorInstance = selector.closest('bundle-quantity-selector')
                if (selectorInstance) {
                  selectorInstance.value = parseInt(item.quantity)
                  console.log("selectorInstance",selectorInstance)
                  selectorInstance.updateBundle()
                }
              }
            }
          })
        }
        // The bundle state has been restored
        window.__bundleStateRestored = true
        return true
      } catch (e) {
        console.error('Failed to restore bundle state:', e)
        return false
      }
    }

    findMatchingProductCards () {
      const allSelectors = document.querySelectorAll('bundle-quantity-selector')
      return [...allSelectors].filter(selector => selector.dataset.bundleOptionId === this.itemID && selector.dataset.isSummarySelector !== 'true')
    }

    syncProductCards () {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')

        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            if (this.value > 0) {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'none'
              : 'flex'
            } else {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'flex'
              : 'none'
            }
          }
          matchingSelector.value = this.value
        }
      })
    }

    initSubscriptionSelector () {
      const onetimeOption = document.querySelector('[data-bsw-onetime-option]')
      const subscriptionOption = document.querySelector('[data-bsw-subscription-option]')

      if (typeof onetimeOption !== 'undefined') {
        onetimeOption.addEventListener('click', () => {
          this.updateBundleSummary()
        })
      }
      if (typeof subscriptionOption !== 'undefined') {
        const subscriptionLabel = subscriptionOption.querySelector('label')
        subscriptionLabel.addEventListener('click', () => {
          this.updateBundleSummary()
        })
      }
    }

    initTypeListeners () {
      this.updateBundleSummary()

      this.bundleTypes.forEach(type => {
        type.addEventListener('click', () => {
          if (this.dataset.isSummarySelector === 'true' || this.currentType === type) {
            this.currentType = type
            return
          }
          this.bundleTypes.forEach(bundleType => bundleType.classList.remove('selected'))
          type.classList.add('selected')

          this.currentType = type
          this.displayActiveOptions(type)
          this.updateSelectorsAndSummary()
          this.updateProductFormId()
          this.updateBundleSummary()
          this.updateSubscriptionWidget()
        })
      })
    }

    updateSubscriptionWidget () {
      const subscriptionOptions = document.querySelectorAll('[data-bundle-product-s-requirement]')
      const widgetOnetimeOption = document.querySelector('[data-bsw-onetime-option]')
      const widgetSubscriptionOption = document.querySelector('[data-bsw-subscription-option]')
      const currentType = document.querySelector('.bundle-product__header-option.selected')
      const defaultOption = document.querySelector('[data-bsw-default-option]')
      const nonSubscriptionProduct = [...subscriptionOptions].find(option => parseInt(option.dataset.bundleProductSRequirement) < 0)

      if (typeof nonSubscriptionProduct === 'undefined') { return }

      widgetSubscriptionOption.style.display = nonSubscriptionProduct.dataset.bundleReference === currentType.dataset.bundleType
        ? 'none'
        : 'block'

      if (typeof defaultOption !== 'undefined' && defaultOption !== null) {
        if (defaultOption.getAttribute('data-bsw-default-option') === 'one_time') {
          const thisInput = widgetOnetimeOption.querySelector('input')
          thisInput.checked = true
          return
        }
      }

      if (nonSubscriptionProduct.dataset.bundleReference === currentType.dataset.bundleType) {
        const thisInput = widgetOnetimeOption.querySelector('input')
        thisInput.checked = true
      } else {
        const thisInput = widgetSubscriptionOption.querySelector('input')
        thisInput.checked = true
      }
    }

    updateProductFormId () {
      const currentType = document.querySelector('.bundle-product__header-option.selected')
      const bundleVariantId = currentType.getAttribute('data-bundle-variant-id')
      const formProductInput = document.querySelector('[data-selected-bundle-type]')
      const formVariantSelect = document.querySelector('[data-bundle-variant-select]')

      formProductInput.setAttribute('data-selected-bundle-type-id', bundleVariantId)
      formVariantSelect.value = bundleVariantId
    }

    displayActiveOptions (selectedType) {
      this.bundleOptions.forEach(option => {
        option.style.display = option.getAttribute('data-bundle-reference') === selectedType.getAttribute('data-bundle-type')
          ? 'block'
          : 'none'
      })
    }

    updateSelectorsAndSummary () {
      const currentBundleItems = this.bundleList.querySelectorAll('bundle-item')
      const allProductCards = document.querySelectorAll('[data-bundle-product-card]')
      let visibleProductIds = []

      // Find all visible product cards
      allProductCards.forEach(card => {
        const parentOption = card.closest('.bundle-product__option')
        if (parentOption !== null && parentOption.style.display !== 'none') {
          visibleProductIds.push(card.getAttribute('data-bundle-product-card'))
        }
      })

      // Reset all selectors for products that are removed from the bundle summary
      currentBundleItems.forEach(item => {
        const itemId = item.getAttribute('data-bundle-item-id')
        const itemType = item.getAttribute('data-bundle-item-type')

        if (!visibleProductIds.includes(itemId) || itemType === '') {
          const allSelfInstances = [...allProductCards].filter(card => card.getAttribute('data-bundle-product-card') === itemId)
          for (let i = 0; i <  allSelfInstances.length; i++) {
            const selfSelector = allSelfInstances[i].querySelector('bundle-quantity-selector')

            for (let j = 0; j < selfSelector.children.length; j++) {
              selfSelector.children[j].style.display = selfSelector.children[j].hasAttribute('data-bqs-add-text')
                ? 'inline-flex'
                : 'none'
            }
          }
          item.remove()
        }
      })
    }

    hideSelectorValues () {
      if (this.dataset.isSummarySelector === 'true') {
        this.value = 0
        return
      }
      try {
        this.addText.style.display = 'flex'
        this.input.style.display = 'none'
        this.add.style.display = 'none'
        this.subtract.style.display = 'none'
        this.value = 0
      } catch (error) {
        console.log(error)
      }
    }

    showSelectorValues () {
      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i]
        child.style.display = child.hasAttribute('data-bqs-add-text')
          ? 'none'
          : 'flex'
      }
    }

    initQuantitySelector () {
      this.add.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue + 1 <= this.max) {
            this.value = inputValue + 1
            this.input.value = this.value
            await this.updateBundle()
            this.syncProductCards()
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.subtract.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue - 1 > 0) {
            this.value = inputValue - 1
            this.input.value = this.value
            await this.updateBundle()
            this.syncProductCards()
          } else if (inputValue - 1 <= 0) {
            this.value = 0
            this.input.value = this.value
            this.removeFromBundle()
            this.hideSelectorValues()
            this.syncProductCards()
            this.updateBundleSummary()
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.input.addEventListener('change', async (e) => {
        const newValue = parseInt(e.target.value)

        if (typeof newValue === 'undefined' || isNaN(newValue)) {
          this.input.value = this.value
          return
        }

        if (newValue < 1) {
          this.value = 0
          this.input.value = this.value
          await this.updateBundle()
          this.hideSelectorValues()
          this.removeFromBundle()
        } else if (newValue <= this.max) {
          this.value = newValue
          this.input.value = this.value
          await this.updateBundle()
        } else if (newValue > this.max) {
          this.value = this.max
          this.input.value = this.value
          await this.updateBundle()
        }
        this.syncProductCards()
      })

      if (typeof this.addText !== 'undefined' && this.addText !== null) {
        this.addText.addEventListener('click', async () => {
          this.value = 1
          this.input.value = this.value
          this.showSelectorValues()
          await this.updateBundle()
          this.syncProductCards()
        })
      }
    }

    // updateCache () {
    //   const bundleItemsData = sessionStorage.getItem('bundleList')

    //   if (bundleItemsData === null || bundleItemsData === '') { return }

    //   const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')
    //   const thisVariant = bundleItemsJson.find(item => item.id === this.itemID)

    //   if (typeof thisVariant === 'undefined') { return }

    //   this.value = parseInt(thisVariant.quantity, 10)
    //   this.input.value = this.value
    // }

    async updateBundle () {
      const variant = this.searchForVariant(this.itemID)

      if (variant === null) { // Add as new bundle item
        if (this.classList.contains('manipulated')) {
          this.value = 1
        }
        const elementTemplate = this.bundleItemTemplate()
        const doc = this.parser.parseFromString(elementTemplate, 'text/html')
        const element = doc.querySelector('bundle-item')
        if (!element) { return }
        this.bundleList.appendChild(element)
      } else { // Update quantity
        const quantityInput = variant.querySelector('[data-bqs-input]')
        quantityInput.value = this.value
        quantityInput.setAttribute('value', this.value)
        this.input.value = this.value
      }

      await this.updateBundleSummary()
    }
    
    // Updated Quantity - Francesco 
    async updateBundleSummary () {
      const bundleItems = document.querySelectorAll('bundle-item')
      const currentType = document.querySelector('.bundle-product__header-option.selected')

      if (typeof bundleItems === 'undefined' || bundleItems === null) { return }

      const bundleOptions = document.querySelectorAll('[data-bundle-product-type]')
      const activeOptions = [...bundleOptions].filter(option => option.dataset.bundleReference === currentType.dataset.bundleType)

      let applicatorORequirement, applicatorSRequirement, refillORequirement, refillSRequirement, applicatorCount, refillCount, addonCount, addonTotal, bundleTotal, bundleCompareTotal, refillTotal, applicatorTotal
      applicatorORequirement = applicatorSRequirement = refillORequirement = refillSRequirement = applicatorCount = refillCount = addonCount = addonTotal = bundleTotal = bundleCompareTotal = refillTotal = applicatorTotal = 0

      const calculateRequirements = async () => {
        for (let i = 0; i < activeOptions.length; i++) {
          if (activeOptions[i].dataset.bundleProductType === 'applicator') {
            applicatorORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            applicatorSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          } else if (activeOptions[i].dataset.bundleProductType === 'refill') {
            refillORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            refillSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          }
        }
      }
      

      const calculateSummaryStats = async () => {
        bundleItems.forEach(item => {
          const quantitySelector = item.querySelector('[data-bqs-input]')
          const quantity = parseInt(quantitySelector.value)
          const productType = item.dataset.bundleItemType

          bundleTotal += parseInt(item.dataset.bundleItem) * quantity
          bundleCompareTotal += parseInt(item.dataset.bundleItemCompareAt) * quantity
          if (productType === 'refill') {
            refillTotal += parseInt(item.dataset.bundleItem) * quantity
          } else if (productType === 'applicator') {
            applicatorTotal += parseInt(item.dataset.bundleItem) * quantity
          } else if (productType === 'add-on') {
            addonTotal += parseInt(item.dataset.bundleItem) * quantity
          }


          if (item.dataset.bundleItemType === 'applicator') {
            applicatorCount += quantity
          } else if (item.dataset.bundleItemType === 'refill') {
            refillCount += quantity
          } else {
            addonCount += quantity
          }
        })
      }

      const updateBundlePrices = async () => {
        const onetimePrice = document.querySelector('[data-bsw-onetime-price]')
        const onetimeComparePrice = document.querySelector('[data-bsw-onetime-compare-price]')
        const compareAtPrice = document.querySelector('[data-bsw-compare-at-price]')
        const discountedPrice = document.querySelector('[data-bsw-discounted-price]')
        const discountEntireBundleElement = document.querySelector('[data-bsw-discount-whole]')
        const discountEntireBundle = discountEntireBundleElement.getAttribute('data-bsw-discount-whole')
        const discountValue = parseInt(discountedPrice.getAttribute('data-bsw-discounted-price')) / 100
        const formattedMoney = Shopify.formatMoney(bundleTotal, theme.moneyFormat)
        const formattedCompareMoney = Shopify.formatMoney(bundleCompareTotal, theme.moneyFormat)

        if (discountEntireBundle === 'true') {
          const discounted = bundleTotal * (1.0 - discountValue)
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = applicatorCount + refillCount <= 0 && addonCount > 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal + applicatorTotal === 0
            ? 'none'
            : 'inline'
          } else {
          const discounted = (refillTotal * (1.0 - discountValue)) + applicatorTotal + addonTotal
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = refillTotal === 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
        }

        onetimePrice.textContent = formattedMoney
        compareAtPrice.textContent = formattedMoney

        if (onetimeComparePrice) {
          onetimeComparePrice.style.display = bundleCompareTotal <= 0
          ? 'none'
          : 'inline'
          onetimeComparePrice.textContent = formattedCompareMoney
        }
      }

      const updateButtonStates = async () => {
        const submitButton = document.querySelector('[data-bundle-submit]')
        const subscriptionPurchaseOption = document.querySelector('[data-bsw-subscription-option]')
        const subscriptionOptionInput = subscriptionPurchaseOption.querySelector('input')
        const buttonStates = document.querySelectorAll('[data-bundle-atc-button-state]')

        if (subscriptionOptionInput.checked) {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount < refillSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        } else {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount >= refillORequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount < refillORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        }
      }

      const updateProgressBar = async () => {
        const savingsBar = document.querySelector('bundle-savings-bar')
        const progressStates = document.querySelectorAll('[data-bsb-qualified-state]')
        const applicatorCountElement = document.querySelector('[data-bsb-applicators-away]')
        const refillCountElement = document.querySelector('[data-bsb-refills-away]')
        const progressBar = document.querySelector('[data-bsb-progress]')

        if (applicatorSRequirement > 0 && refillSRequirement > 0) { // applicators and refills
          savingsBar.style.display = 'block'

          const progressTotal = applicatorSRequirement + refillSRequirement
          const applicatorPercent = applicatorCount >= applicatorSRequirement
            ? applicatorSRequirement
            : applicatorCount
          const refillPercent = refillCount >= refillSRequirement
            ? refillSRequirement
            : refillCount
          const totalPercentage = (applicatorPercent + refillPercent) / progressTotal * 100
          progressBar.style.width = totalPercentage + '%'

          if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'qualified')
            })
          } else {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'unqualified' && state.dataset.bsbQualifiedState !== 'applicators' && state.dataset.bsbQualifiedState !== 'refills')
            })
          }
          applicatorCountElement.textContent = applicatorSRequirement
          refillCountElement.textContent = refillSRequirement
        } else if (refillSRequirement > 0) { // refills only
          savingsBar.style.display = 'block'

          const progressTotal = refillSRequirement
          const refillPercent = refillCount >= refillSRequirement
            ? refillSRequirement / progressTotal * 100
            : refillCount / progressTotal * 100
          progressBar.style.width = refillPercent + '%'

          if (refillCount >= refillSRequirement) {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'qualified')
            })
          } else {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'unqualified' && state.dataset.bsbQualifiedState !== 'refills')
            })
          }
          applicatorCountElement.textContent = ''
          refillCountElement.textContent = refillSRequirement
        } else if (applicatorSRequirement < 0 || refillSRequirement < 0) { // no subscription plan available
          savingsBar.style.display = 'none'
        }
      }

      const updateMobileFAB = async () => {
        const mobileFAB = document.querySelector('mobile-bundle-fab')

        if (mobileFAB === null || typeof mobileFAB === 'undefined') { return }

        const productCountEl = mobileFAB.querySelector('[data-fab-products-quantity]')
        productCountEl.textContent = applicatorCount + refillCount + addonCount
      }

      await calculateRequirements()
        .then(calculateSummaryStats())
        .then(updateBundlePrices())
        .then(updateButtonStates())
        .then(updateProgressBar())
        .then(updateMobileFAB())
    }

    removeFromBundle () {
      const variant = this.searchForVariant(this.itemID)
      this.bundleList.removeChild(variant)
      // Update cache
        // const itemData = `{"id":"${this.itemID}","cid":"${this.itemCID}","quantity":"${this.value + 1}","sellingPlans":"${this.itemSellingPlanIDs}","title":"${this.itemTitle}","image":"${this.itemImage}","price":"${this.itemPrice}","type":"${this.itemType},"max":"${this.itemMax}"}`
        // const bundleItemsData = sessionStorage.getItem('bundleList')

        // const updatedData = bundleItemsData === null
        //   ? bundleItemsData.replace(itemData, '')
        //   : bundleItemsData.replace(itemData + ',', '')

        // sessionStorage.setItem('bundleList', updatedData)
    }

    searchForVariant (id) {
      return this.bundleList.querySelector(`[data-bundle-item-id="${id}"]`)
    }

    bundleItemTemplate (id = this.itemID, cid = this.itemCID, quantity = this.value, sellingPlans = this.itemSellingPlanIDs, title = this.itemTitle, image = this.itemImage, price = this.itemPrice, comparePrice = this.itemComparePrice, type = this.itemType, max = this.itemMax) {
      return `
        <bundle-item class="bundle-item"
          data-bundle-item="${price}"
          data-bundle-item-compare-at="${comparePrice}"
          data-bundle-item-collection-id="${cid}"
          data-bundle-item-id="${id}"
          data-bundle-item-selling-plan-ids="${sellingPlans}"
          data-bundle-item-type="${type}"
        >
          <div class="bundle-item__image">
            ${`<img src="${image}&width=100" width="100" height="100" loading="lazy" alt="${title}">`}
          </div>

          <div class="bundle-item__content">
            <div class="bundle-item__link">
              <h4 class="bundle-item__title">${title}</h4>
            </div>

            <div class="bundle-item__quantity">
              <bundle-quantity-selector
                class="quantity-input"
                data-bundle-option-id="${id}"
                data-is-summary-selector="true"
              >
                <button
                  type="button"
                  class="quantity-input__button product__quantity-subtract-item"
                  data-bqs-subtract
                  aria-label="Minus"
                >

                <span class="icon icon-minus-small">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 10.75H.25v2.5H1.5v-2.5zm21 2.5h1.25v-2.5H22.5v2.5zm-21 0H12v-2.5H1.5v2.5zm10.5 0h10.5v-2.5H12v2.5z" fill="currentColor"/>
                  </svg>
                </span>

                </button>
                <label class="visually-hidden" for="Quantity-Input-${id}">Quantity</label>
                <input
                  type="number"
                  name="updates[]"
                  id="Quantity-Input-${id}"
                  value="${quantity}"
                  min="1"
                  max="${max}"
                  pattern="[0-9]*"
                  class="quantity-input__input"
                  data-bqs-input
                  aria-label="Quantity"
                />
                <button
                  type="button"
                  class="quantity-input__button product__quantity-add-item"
                  data-bqs-add
                  aria-label="Add"
                >

                  <span class="icon icon-plus-small">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.25 1.5V.25h-2.5V1.5h2.5zm-2.5 21v1.25h2.5V22.5h-2.5zM1.5 10.75H.25v2.5H1.5v-2.5zm21 2.5h1.25v-2.5H22.5v2.5zm-21 0H12v-2.5H1.5v2.5zm10.5 0h10.5v-2.5H12v2.5zM10.75 1.5V12h2.5V1.5h-2.5zm0 10.5v10.5h2.5V12h-2.5z" fill="currentColor"/>
                    </svg>
                  </span>
                </button>
              </bundle-quantity-selector>
            </div>

            <button class="bundle-item__remove" data-remove-bundle-item type="button" aria-label="Remove ${title} from your bundle">
              <span class="icon icon-plus-small">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.717 1.975 3.347.605.604 3.346l1.37 1.37 2.742-2.74zm14.566 20.05 1.37 1.37 2.742-2.741-1.37-1.37-2.742 2.74zm2.742-17.308 1.37-1.37L20.654.604l-1.37 1.37 2.74 2.742zM1.975 19.283l-1.37 1.37 2.741 2.742 1.37-1.37-2.74-2.742zm0-14.566 8.654 8.654 2.742-2.742-8.654-8.654-2.742 2.742zm11.396 8.654 8.654-8.654-2.742-2.742-8.654 8.654 2.742 2.742zm-2.742-2.742-8.654 8.654 2.742 2.741 8.654-8.653-2.742-2.742zm0 2.742 8.654 8.653 2.742-2.74-8.654-8.655-2.742 2.742z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          </div>
        </bundle-item>
      `
    }
  })

  /**=================================================================
   * Mobile Jump To Summary FAB
   * =================================================================
  */
  window.customElements.define('mobile-bundle-fab', class MobileBundleFAB extends HTMLElement {
    constructor () {
      super()

      this.topThreshold = document.querySelector('[data-bundle-fab-top]')
      this.bottomThreshold = document.querySelector('[data-bundle-fab-bottom]')

      if (typeof this.topThreshold === 'undefined' || this.topThreshold === null || typeof this.bottomThreshold === 'undefined' || this.bottomThreshold === null) { return }

      this.initMobileFAB()
    }

    initMobileFAB () {
      function isInViewRange (upper, lower) {
        const upperRect = upper.getBoundingClientRect()
        const lowerRect = lower.getBoundingClientRect()
        const upperBound = window.innerHeight - upperRect.bottom
        const lowerBound = window.innerHeight - lowerRect.top

        return (upperBound > 0 && lowerBound < 0)
      }

      window.addEventListener('scroll', (e) => {
        this.style.transform = isInViewRange(this.topThreshold, this.bottomThreshold)
          ? 'translateY(0)'
          : 'translateY(100%)'

        this.style.opacity = isInViewRange(this.topThreshold, this.bottomThreshold)
          ? '1'
          : '0'
      })

      this.addEventListener('click', () => {
        this.bottomThreshold.scrollIntoView({ behavior: "smooth" })
      })
    }
  })

  /**=================================================================
   * Bundle Summary Items
   * =================================================================
  */
  window.customElements.define('bundle-item', class BundleItem extends HTMLElement {
    constructor () {
      super()

      this.id = this.dataset.bundleItemId
      this.removeButton = this.querySelector('[data-remove-bundle-item]')
      this.quantitySelector = this.querySelector('bundle-quantity-selector')
      this.mainQuantitySelectors = document.querySelectorAll('[data-bundle-quantity-selector]')
      this.input = this.querySelector('[data-bqs-input]')
      this.add = this.querySelector('[data-bqs-add]')
      this.subtract = this.querySelector('[data-bqs-subtract]')
      this.max = parseInt(this.input.getAttribute('max'))
      this.matchingProductCards = this.findMatchingProductCards()
      this.matchingBundleSelectors = null

      this.initRemoveButton()
      this.initQuantitySelector()
    }

    updateQuantities () {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')
        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          matchingCard.classList.add('manipulated')
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
            ? 'flex'
            : 'none'
          }
        }
      })
    }

    initRemoveButton () {
      this.removeButton.addEventListener('click', (event) => {
        event.preventDefault()
        this.removeFromBundle()
      })
    }
    
    async updateBundleSummary () {
      const bundleItems = document.querySelectorAll('bundle-item')
      const currentType = document.querySelector('.bundle-product__header-option.selected')

      const bundleOptions = document.querySelectorAll('[data-bundle-product-type]')
      const activeOptions = [...bundleOptions].filter(option => option.dataset.bundleReference === currentType.dataset.bundleType)

      let applicatorORequirement, applicatorSRequirement, refillORequirement, refillSRequirement, applicatorCount, refillCount, addonCount, addonTotal, bundleTotal, bundleCompareTotal, refillTotal, applicatorTotal
      applicatorORequirement = applicatorSRequirement = refillORequirement = refillSRequirement = applicatorCount = refillCount = addonCount = addonTotal = bundleTotal = bundleCompareTotal = refillTotal = applicatorTotal = 0

      const calculateRequirements = async () => {
        for (let i = 0; i < activeOptions.length; i++) {
          if (activeOptions[i].dataset.bundleProductType === 'applicator') {
            applicatorORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            applicatorSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          } else if (activeOptions[i].dataset.bundleProductType === 'refill') {
            refillORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            refillSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          }
        }
      }

      const calculateSummaryStats = async () => {
        bundleItems.forEach(item => {
          if (item.dataset.bundleItemId !== this.id) {
            const quantitySelector = item.querySelector('[data-bqs-input]')
            const quantity = parseInt(quantitySelector.value)
            const productType = item.dataset.bundleItemType

            bundleTotal += parseInt(item.dataset.bundleItem) * quantity
            bundleCompareTotal += parseInt(item.dataset.bundleItemCompareAt) * quantity
            if (productType === 'refill') {
              refillTotal += parseInt(item.dataset.bundleItem) * quantity
            } else if (productType === 'applicator') {
              applicatorTotal += parseInt(item.dataset.bundleItem) * quantity
            } else if (productType === 'add-on') {
              addonTotal += parseInt(item.dataset.bundleItem) * quantity
            }

            if (item.dataset.bundleItemType === 'applicator') {
              applicatorCount += quantity
            } else if (item.dataset.bundleItemType === 'refill') {
              refillCount += quantity
            } else {
              addonCount += quantity
            }
          }
        })
      }

      const updateBundlePrices = async () => {
        const onetimePrice = document.querySelector('[data-bsw-onetime-price]')
        const onetimeComparePrice = document.querySelector('[data-bsw-onetime-compare-price]')
        const compareAtPrice = document.querySelector('[data-bsw-compare-at-price]')
        const discountedPrice = document.querySelector('[data-bsw-discounted-price]')
        const discountEntireBundleElement = document.querySelector('[data-bsw-discount-whole]')
        const discountEntireBundle = discountEntireBundleElement.getAttribute('data-bsw-discount-whole')
        const discountValue = parseInt(discountedPrice.getAttribute('data-bsw-discounted-price')) / 100
        const formattedMoney = Shopify.formatMoney(bundleTotal, theme.moneyFormat)
        const formattedCompareMoney = Shopify.formatMoney(bundleCompareTotal, theme.moneyFormat)
        console.log("bundleTotal",bundleTotal)
        if (discountEntireBundle === 'true') {
          const discounted = bundleTotal * (1.0 - discountValue)
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = applicatorCount + refillCount <= 0 && addonCount > 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal + applicatorTotal === 0
            ? 'none'
            : 'inline'
          } else {
          const discounted = (refillTotal * (1.0 - discountValue)) + applicatorTotal + addonTotal
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = refillTotal === 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
        }

        onetimePrice.textContent = formattedMoney
        compareAtPrice.textContent = formattedMoney
        if (onetimeComparePrice) {
          onetimeComparePrice.style.display = bundleCompareTotal <= 0
          ? 'none'
          : 'inline'
          onetimeComparePrice.textContent = formattedCompareMoney
        }
      }

      const updateButtonStates = async () => {
        const submitButton = document.querySelector('[data-bundle-submit]')
        const subscriptionPurchaseOption = document.querySelector('[data-bsw-subscription-option]')
        const subscriptionOptionInput = subscriptionPurchaseOption.querySelector('input')
        const buttonStates = document.querySelectorAll('[data-bundle-atc-button-state]')

        if (subscriptionOptionInput.checked) {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount < refillSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        } else {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount >= refillORequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount < refillORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        }
      }

      const updateProgressBar = async () => {
        const savingsBar = document.querySelector('bundle-savings-bar')
        const progressStates = document.querySelectorAll('[data-bsb-qualified-state]')
        const applicatorCountElement = document.querySelector('[data-bsb-applicators-away]')
        const refillCountElement = document.querySelector('[data-bsb-refills-away]')
        const progressBar = document.querySelector('[data-bsb-progress]')

        if (applicatorSRequirement > 0 && refillSRequirement > 0) { // applicators and refills
          savingsBar.style.display = 'block'

          const progressTotal = applicatorSRequirement + refillSRequirement
          const applicatorPercent = applicatorCount >= applicatorSRequirement
            ? applicatorSRequirement
            : applicatorCount
          const refillPercent = refillCount >= refillSRequirement
            ? refillSRequirement
            : refillCount
          const totalPercentage = (applicatorPercent + refillPercent) / progressTotal * 100
          progressBar.style.width = totalPercentage + '%'

          if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'qualified')
            })
          } else {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'unqualified' && state.dataset.bsbQualifiedState !== 'applicators' && state.dataset.bsbQualifiedState !== 'refills')
            })
          }
          applicatorCountElement.textContent = applicatorSRequirement
          refillCountElement.textContent = refillSRequirement
        } else if (refillSRequirement > 0) { // refills only
          savingsBar.style.display = 'block'

          const progressTotal = refillSRequirement
          const refillPercent = refillCount >= refillSRequirement
            ? refillSRequirement / progressTotal * 100
            : refillCount / progressTotal * 100
          progressBar.style.width = refillPercent + '%'

          if (refillCount >= refillSRequirement) {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'qualified')
            })
          } else {
            progressStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bsbQualifiedState !== 'unqualified' && state.dataset.bsbQualifiedState !== 'refills')
            })
          }
          applicatorCountElement.textContent = ''
          refillCountElement.textContent = refillSRequirement
        } else if (applicatorSRequirement < 0 || refillSRequirement < 0) { // no subscription plan available
          savingsBar.style.display = 'none'
        }
      }

      const updateMobileFAB = async () => {
        const mobileFAB = document.querySelector('mobile-bundle-fab')

        if (mobileFAB === null || typeof mobileFAB === 'undefined') { return }

        const productCountEl = mobileFAB.querySelector('[data-fab-products-quantity]')
        productCountEl.textContent = applicatorCount + refillCount + addonCount
      }

      await calculateRequirements()
        .then(calculateSummaryStats())
        .then(updateBundlePrices())
        .then(updateButtonStates())
        .then(updateProgressBar())
        .then(updateMobileFAB())
    }
    
    async removeFromBundle () {
      // const bundleItemsData = sessionStorage.getItem('bundleList')
      // const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')
      // const bundleItemsWithoutMe = bundleItemsJson.filter(item => item.id !== this.id)
      // const bundleItemsStr = JSON.stringify(bundleItemsWithoutMe)
      // const bundleItemFormatted = bundleItemsStr.substring(1, bundleItemsStr.length-1)
      // sessionStorage.setItem('bundleList', bundleItemFormatted)
      this.updateQuantities()
      this.updateBundleSummary()
      this.remove()
    }

    findMatchingProductCards () {
      this.allSelectors = document.querySelectorAll('bundle-quantity-selector')
      return [...this.allSelectors].filter(selector => selector.dataset.bundleOptionId === this.id && selector.dataset.isSummarySelector !== 'true')
    }

    updateProductCards (newValue) {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')

        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            if (newValue > 0) {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'none'
              : 'flex'
            } else {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'flex'
              : 'none'
            }
          }
          matchingSelector.value = newValue
        }
      })
    }

    initQuantitySelector () {
      this.add.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue + 1 <= this.max) {
            this.updateProductCards(inputValue + 1)
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.subtract.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue - 1 > 0) {
            this.updateProductCards(inputValue - 1)
          } else {
            this.updateProductCards(0)
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.input.addEventListener('change', async (e) => {
        const newValue = parseInt(e.target.value)
        if (newValue < 1) {
          await this.removeFromBundle()
        }
        this.updateProductCards(newValue)
      })
    }
    
  })

  // Add a new custom element for the bundle product to handle URL state restoration
  window.customElements.define('bundle-product-container', class BundleProductContainer extends HTMLElement {
    constructor() {
      super()
      
      // Wait for DOM to be fully loaded before attempting to restore state
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => this.restoreBundleStateFromURL(), 500)
        })
      } else {
        setTimeout(() => this.restoreBundleStateFromURL(), 500)
      }
    }
    
  })
  
  // remove items from cart
  
  // const removeBundlesFromCart = document.querySelectorAll('[data-remove-bundle-items]');

  // removeBundlesFromCart.forEach(button => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-remove-bundle-items]');
      if (!button) return;
    
      const bundleGroup = button.closest('[data-id]');
      const bundleId = bundleGroup?.getAttribute('data-id');
      if (!bundleId) return;
    
      try {
        const cartData = await fetch('/cart.js').then(res => res.json());
        const updates = {};
    
        cartData.items.forEach(item => {
          if (item.properties && item.properties._bundle_state_url === bundleId && item.key) {
            updates[item.key] = 0;
    
            if (typeof window.cart?.updateItem === 'function') {
              window.cart.updateItem(item.key, 0);
            }
          }
        });
    
        // If no cart.updateItem, fallback to cart/update.js
        if (typeof window.cart?.updateItem !== 'function' && Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
    
        // Remove group DOM node immediately
        if (bundleGroup) bundleGroup.remove();
    
        // Force cart refresh – always reliable
        if (window.fluorescent?.Cart?.fetchAndRender) {
          await window.fluorescent.Cart.fetchAndRender();
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
    
        // Re-dispatch with unique detail
        const event = new CustomEvent('apps:product-added-to-cart', {
          detail: { timestamp: Date.now() }
        });
        document.dispatchEvent(event);
    
      } catch (err) {
        console.error('Error removing bundle:', err);
      }
    });
  // });


  
})()
  
